import UserList from './List';
import UserView from './Form';

export default {
  list: UserList,
  edit: UserView,
};